export default "__VITE_ASSET__DTJqu$TZ__"